export const SITE = {
  name: "STYLE PEINTURE DECORATION",
  owner: "Sinan Boz",
  legalForm: "Entrepreneur individuel",
  founded: "2021",
  city: "Angers",
  region: "Maine-et-Loire",
  phone: "06 66 32 08 89",
  phoneHref: "tel:+33666320889",
  email: "contact@stylepeinture.fr",
  address: "8 rue Marc Sangnier, 49000 Angers",
  siret: "SIRET 903 121 853 00019",
  siren: "903 121 853",
  naf: "43.34Z — Travaux de peinture et vitrerie",
  radius: "100 km",
  socials: [
    { name: "Instagram", handle: "@stylepeinturedecoration", url: "https://www.instagram.com/stylepeinturedecoration/" },
    { name: "Facebook", handle: "Stylepeinturedecoration", url: "https://www.facebook.com/Stylepeinturedecoration" },
  ],
  mainCities: [
    { name: "Nantes", km: 90, deg: 195 },
    { name: "Cholet", km: 60, deg: 115 },
    { name: "Saumur", km: 50, deg: 25 },
    { name: "Tours", km: 105, deg: 355 },
    { name: "Laval", km: 75, deg: 250 },
  ],
  hours: [
    ["Lundi – Vendredi", "8h00 – 18h30"],
    ["Samedi", "9h00 – 12h00 (sur RDV)"],
    ["Dimanche", "Fermé"],
  ],
  communes: [
    "Angers", "Nantes", "Saumur", "Cholet", "Tours", "Laval",
    "Avrillé", "Trélazé", "Les Ponts-de-Cé", "Saint-Barthélemy-d'Anjou", "Beaucouzé",
    "Segré-en-Anjou Bleu", "Château-Gontier", "Ancenis", "La Flèche", "Chinon", "Saint-Herblain", "Rezé",
  ],
};

export const EASE = [0.19, 1, 0.22, 1];

export const IMG = {
  hero: "https://static.prod-images.emergentagent.com/jobs/91751ac1-911b-4f26-b498-fabde468a697/images/423a00c502844a98f76cd618b195206776719ca8fc0a5833423300956ca1ff29.jpeg",
  salonAfter: "https://static.prod-images.emergentagent.com/jobs/91751ac1-911b-4f26-b498-fabde468a697/images/8130220d2c8bb1634f017fb5a82fb2704c2d1b8d79bdcef834e42e38b0e3b2f4.jpeg",
  salonBefore: "https://static.prod-images.emergentagent.com/jobs/91751ac1-911b-4f26-b498-fabde468a697/images/007131f4ac1b112cffeb415621847eff44f5d8b41f255117b360ff2c5bc3c659.jpeg",
  facadeAfter: "https://static.prod-images.emergentagent.com/jobs/91751ac1-911b-4f26-b498-fabde468a697/images/a628d4a5d45a7462e56d093c03adbfc5aab53f15944e385adeeea9e786b1b908.jpeg",
  facadeBefore: "https://static.prod-images.emergentagent.com/jobs/91751ac1-911b-4f26-b498-fabde468a697/images/55e428b5a0a0f9e25624c879b40ae249421718a67cfc9c3c55f2f62001500081.jpeg",
  chambreAfter: "https://static.prod-images.emergentagent.com/jobs/91751ac1-911b-4f26-b498-fabde468a697/images/39c512b9427f82076b6f2cbac20f2dce3a5df333c176d9783355bd6ec9278795.jpeg",
  chambreBefore: "https://static.prod-images.emergentagent.com/jobs/91751ac1-911b-4f26-b498-fabde468a697/images/91e71093184bcaaa5fa3dfc6709574c11e11b0ec7ed7a035efeb7936cc375579.jpeg",
  blueRoom: "https://images.unsplash.com/photo-1615971677499-5467cbab01c0?crop=entropy&cs=srgb&fm=jpg&q=80&w=1600",
  roller: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  painter: "https://images.pexels.com/photos/7218579/pexels-photo-7218579.jpeg?auto=compress&cs=tinysrgb&w=1400",
  parquet: "https://images.unsplash.com/photo-1761053130711-2515ef532bb5?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  scaffold: "https://images.unsplash.com/photo-1777984947115-05de206fd91d?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
  houseCream: "https://images.unsplash.com/photo-1760441981748-6a1180301478?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400",
};
